import {
    CTRL_GET_COUNTRY,
    CTRL_GET_COUNTRY_DETAILS,
    CTRL_CREATE_COUNTRY,
    CTRL_EDIT_COUNTRY,
    CTRL_DELETE_COUNTRY,

    CTRL_GET_STATE,
    CTRL_GET_STATE_DETAILS,
    CTRL_CREATE_STATE,
    CTRL_EDIT_STATE,
    CTRL_DELETE_STATE,
    CTRL_GET_CITY,
    CTRL_GET_CITY_DETAILS,
    CTRL_CREATE_CITY,
    CTRL_EDIT_CITY,
    CTRL_DELETE_CITY
} from '../../../actions/index.types';


export function getCountries(data) {
    return {
        type: CTRL_GET_COUNTRY,
        data
    }
}

export function getCountryDetails(data) {
    return {
        type: CTRL_GET_COUNTRY_DETAILS,
        data
    }
}

export function createCountry(data) {
    return {
        type: CTRL_CREATE_COUNTRY,
        data
    }
}

export function editCountry(data) {
    return {
        type: CTRL_EDIT_COUNTRY,
        data
    }
}

export function deleteCountry(data) {
    return {
        type: CTRL_DELETE_COUNTRY,
        data
    }
}



export function getStates(data) {
    return {
        type: CTRL_GET_STATE,
        data
    }
}

export function getStateDetails(data) {
    return {
        type: CTRL_GET_STATE_DETAILS,
        data
    }
}

export function createState(data) {
    return {
        type: CTRL_CREATE_STATE,
        data
    }
}

export function editState(data) {
    return {
        type: CTRL_EDIT_STATE,
        data
    }
}

export function deleteState(data) {
    return {
        type: CTRL_DELETE_STATE,
        data
    }
}


/* =========================
   GET CITIES
========================= */
export function getCities(data) {
    return {
        type: CTRL_GET_CITY,
        data
    };
}

/* =========================
   GET CITY DETAILS
========================= */
export function getCityDetails(data) {
    return {
        type: CTRL_GET_CITY_DETAILS,
        data
    };
}

/* =========================
   CREATE CITY
========================= */
export function createCity(data) {
    return {
        type: CTRL_CREATE_CITY,
        data
    };
}

/* =========================
   EDIT CITY
========================= */
export function editCity(data) {
    return {
        type: CTRL_EDIT_CITY,
        data
    };
}

/* =========================
   DELETE CITY
========================= */
export function deleteCity(data) {
    return {
        type: CTRL_DELETE_CITY,
        data
    };
}